import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Home from "@/pages/Home";
import AdminLogin from "@/pages/AdminLogin";
import AdminDashboard from "@/pages/AdminDashboard";
import { Toaster } from "sonner";

function App() {
  return (
    <div className="App">
      <Toaster
        position="top-right"
        theme="dark"
        toastOptions={{
          unstyled: false,
          classNames: {
            toast: "!bg-surface !border !border-line !rounded-sm !shadow-none !font-sans",
            title: "!text-fg !text-[13px] !font-medium",
            description: "!text-mute !text-xs",
            actionButton: "!bg-brand !text-white !rounded-sm",
            cancelButton: "!bg-surface-2 !text-mute !rounded-sm",
            closeButton: "!bg-surface !border-line !text-mute",
            success: "!border-l-2 !border-l-emerald-500",
            error: "!border-l-2 !border-l-red-500",
          },
        }}
      />
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/admin" element={<AdminLogin />} />
          <Route path="/admin/dashboard" element={<AdminDashboard />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
